<div class="container">
  <div class="row">
    <div class="col-8 col-sm-10">
      <div class="left-col">
        <span>
          <p class="data" *ngIf="data?.status === 'success'">{{data?.message}}</p>
          <p class="data" *ngIf="data?.status === 'failure'">{{data?.message}}</p>
          <p class="data" *ngIf="data?.status === 'failureDigitalCard' && data?.message !== 'Failed to Update'">{{data?.message}}</p>
          <p class="data" *ngIf="data?.status === 'failureDigitalCard' && data?.message === 'Failed to Update'">Looks like something went wrong but we're working on it and will be back soon.</p>
          <p class="data" *ngIf="data?.status === 'info'">{{data?.message}}</p>
          <p class="data" *ngIf="data?.status === 'alert'">
            {{data?.message}}
          </p>
        </span>
      </div>
    </div>
    <div class="col-2 d-flex align-items-center">
      <div class="dismiss">
        <button type="button" class="btn btn-primary btn-xs" (click)="snackBarRef.dismiss()">Close</button>
      </div>
    </div>
  </div>
</div>